import { Dialog } from '@material-ui/core'
import React from 'react'

const DetailsFullScreen = ({ source, setOpenFullScreen }) => {

    const handleClose = () => {
        setOpenFullScreen(false)
    }

    return (
        <Dialog
            id="autom-store-fullscreen"
            className="autom-group"
            open={true}
            onClose={handleClose}
            PaperProps={{
                style: {
                    minWidth: "95%",
                    maxWidth: "95%",
                    width: "100%",
                    height: "100%",
                    borderRadius: " 4px",
                    padding: "4px 22px"
                },
            }}
        >
            <img className='autom-store-fullscreen-image' src={source} />
        </Dialog >
    )
}

export default DetailsFullScreen